//Function to navigate to XEOKIT Viewer in full screen mode in interactive component

const handleFullscreenXeokit = () => {
    window.location.href = "/xeokit-viewer";
  };
  export default handleFullscreenXeokit;